import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-px-lg q-pb-md" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "col-2 q-gutter-y-md" }

import TimelineHeaderDate from '../components/TimelineHeaderDate.vue'
import TimelineBase from '../components/TimelineBase.vue'
import TimelineScorecardsAll from '../components/TimelineScorecardsAll.vue'
import BannerProcessing from '../components/BannerProcessing.vue'
import BannerDeniedTimecard from '../components/BannerDeniedTimecard.vue'
import TimelineWelcomeMessage from '../components/timeline/TimelineWelcomeMessage.vue'
import { inject, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useStoreProfiles } from '../store/useStoreProfiles'
import { useTaskProfiles } from '../store/useTaskProfiles'

export default /*#__PURE__*/_defineComponent({
  __name: 'PageTimeline',
  setup(__props) {

const date = inject('date')
const setDate = inject<(date: Date) => void>('setDate')
//this is where the active timecard would be set back to today
if (setDate) setDate(new Date())
onMounted(() => {
  setTimeout(() => {
    //calc busiest data behind scenes w/o clogging the main thread
    const { getStores, getWorkView } = storeToRefs(useStoreProfiles())
    const { taskIndex } = storeToRefs(useTaskProfiles())
    getStores.value
    getWorkView.value
    taskIndex.value
  }, 0)
})
function styleFn(offset: any) {
  return { minHeight: offset ? `calc(97vh - ${offset}px)` : '100vh' }
}

return (_ctx: any,_cache: any) => {
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, {
    "style-fn": styleFn,
    class: "q-pt-sm"
  }, {
    default: _withCtx(() => [
      _createVNode(BannerDeniedTimecard),
      _createVNode(BannerProcessing),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(TimelineHeaderDate, { date: _unref(date) }, null, 8, ["date"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(TimelineWelcomeMessage),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(TimelineBase)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(TimelineScorecardsAll, { date: _unref(date) }, null, 8, ["date"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})